import React, { useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import { Link } from "react-router-dom";
import { logout } from "../../reducers/auth";
import { getUserDetails } from "../../reducers/auth";
import { getHeaderProps } from "../../reducers/headerProps";
import { PARTNER_CC_ROLE_ID } from "../../constant/status_constant";

const Navbar = ({ isDisplay, setDisplay }) => {
  let dispatch = useDispatch();
  let user = useSelector((state) => state.authReducer.currentUser);
  let headerProps = useSelector((state) => state.headerProps.headerProps);

  const handlelogout = () => {
    dispatch(logout());
  };

  useEffect(() => {
    // Dispatch the getUserDetails action when the component mounts
    dispatch(getUserDetails());
    dispatch(getHeaderProps());
  }, [dispatch]);

  return (
    <>
      <nav className="main-header navbar navbar-expand navbar-white navbar-light admin-navbar">
        {/* Left navbar links */}
        <ul className="navbar-nav">
          <li
            className="nav-item"
            onClick={() => {
              setDisplay(!isDisplay);
            }}
          >
            <Link
              className="nav-link"
              data-widget="pushmenu"
              to={"#"}
              role="button"
            >
              <i className="fa-solid fa-bars" aria-hidden="true" />
            </Link>
          </li>
          <li className="nav-item  d-none d-sm-inline-block">
            <Link to={"#"} className="nav-link">
              {headerProps && (
                <>
                  {headerProps.breadcrumbTitle}{" "}
                  {headerProps.breadcrumbSubTitle && (
                    <>/ {headerProps.breadcrumbSubTitle}</>
                  )}
                </>
              )}
            </Link>
          </li>
        </ul>
        <ul className="navbar-nav ml-auto">
          <li className="nav-item d-none d-sm-inline-block admin-search">
            <form action="/search" method="get" className="admin-search-form">
              <i
                className="fas fa-search admin-search-icon"
                aria-hidden="true"
              />
              <input
                type="text"
                className="form-control form-control-navbar customSearch"
                placeholder="Search"
                aria-label="Search"
                name="keyword"
              />
            </form>
          </li>
        </ul>
        {/* Right navbar links */}
        <ul className="navbar-nav ml-auto">
          {user?.role_id !== PARTNER_CC_ROLE_ID && (
            <li className="nav-item ">
              <Link
                to={"/createbooking"}
                target="_blank"
                className="nav-link admin-booking-link"
              >
                Add Booking
              </Link>
            </li>
          )}

          {headerProps.navButton && (
            <>
              <li className="nav-item ">{headerProps.navButton}</li>
            </>
          )}

          <li className="nav-item dropdown">
            <Link
              className="nav-link dropdown-toggle admin-profile-link"
              data-toggle="dropdown"
              to={"#"}
              aria-expanded="true"
              aria-haspopup="true"
            >
              {user && user.picture ? (
                <img
                  src={user.picture}
                  alt="Profile"
                  className="rounded-circle"
                  style={{ width: "25px", height: "25px" }}
                />
              ) : (
                <i className="far fa-user" />
              )}
              &nbsp;&nbsp;&nbsp;{user && <>{user.name}</>}
            </Link>
            <div
              className="dropdown-menu dropdown-menu-right admin-profile-menu"
              aria-labelledby="navbarDropdown"
            >
              {/* <span className="dropdown-item dropdown-header">15 Notifications</span> */}
              <Link
                to={"#"}
                onClick={() => {
                  handlelogout();
                }}
                className="dropdown-item"
              >
                <i className="fas fa-sign-out-alt" /> Signout
              </Link>
              <div className="dropdown-divider"></div>
              <Link to={"/resetpassword"} className="dropdown-item">
                <i className="fas fa-lock" /> Reset Password
              </Link>
            </div>
          </li>
        </ul>
      </nav>
    </>
  );
};

export default Navbar;
